import PropTypes from "prop-types";
import TimelineHandwrittenCampaignCard from "./TimelineHandwrittenCampaignCard";
import { formatDate, parseDate } from "./helpers/campaignDate";

const TimelineHandwrittenCampaignEvent = ({ event }) => {
  const { timeline_fields: timelineFields, interacted_at_absolute: interactedAtAbsolute } = event;
  const {
    updater_name: updaterName,
    campaign_id: campaignId,
    campaign_name: campaignName,
    send_at: sendAt,
    submitted_at: submittedAt,
    delivery_id: deliveryId,
    recipient_address: recipientAddress,
  } = timelineFields;

  return (
    <TimelineHandwrittenCampaignCard
      action="ordered"
      actor={updaterName || "Someone"}
      interactedAt={interactedAtAbsolute}
      campaignId={campaignId}
      campaignName={campaignName}
      deliveryId={deliveryId}
      recipientAddress={recipientAddress}
      displayDate={formatDate(parseDate(sendAt)) || formatDate(parseDate(submittedAt))}
    />
  );
};

TimelineHandwrittenCampaignEvent.propTypes = {
  event: PropTypes.shape({
    timeline_fields: PropTypes.shape({
      updater_name: PropTypes.string,
      campaign_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      campaign_name: PropTypes.string,
      send_at: PropTypes.string,
      submitted_at: PropTypes.string,
      delivery_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      recipient_address: PropTypes.shape({
        address1: PropTypes.string,
        address2: PropTypes.string,
        city: PropTypes.string,
        state: PropTypes.string,
        postcode: PropTypes.string,
        country: PropTypes.string,
      }),
    }),
    interacted_at_absolute: PropTypes.string,
  }).isRequired,
};

export default TimelineHandwrittenCampaignEvent;
